import { render } from "./demos.vue?vue&type=template&id=65929e9e&scoped=true"
import script from "./demos.vue?vue&type=script&lang=js"
export * from "./demos.vue?vue&type=script&lang=js"

import "./demos.vue?vue&type=style&index=0&id=65929e9e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65929e9e"]])

export default __exports__